import React from "react";
import { ExternalLink, FileText, Search } from "lucide-react";
import "./DecisionLieeArticle.css";

const DecisionLieeArticle = ({ articleId, decision }) => {
    const decisions = Array.isArray(decision) ? decision : [];

    if (!decisions || decisions?.length === 0) {
        return (
            <div className="decisions-liees empty-decisions">
                <div className="decisions-header">
                    <h2>
                        Décisions de justice liées
                    </h2>
                </div>
                <p>Aucune décision liée à cet article</p>
            </div>
        );
    }

    return (
        <div className="decisions-liees">
            <div className="decisions-header">
                <h2>
                    Décisions de justice liées
                </h2>
                {decisions.length > 5 && (
                    <a href="#" className="voir-toutes">
                        Voir toutes les décisions
                        <ExternalLink size={14} className="ml-1" />
                    </a>
                )}
            </div>

            <div className="decisions-list">
                {decisions.slice(0, 5).map((decision) => (
                    <div key={decision.id} className="decision-item">
                        <div className="decision-meta">
                            <FileText size={18} className="document-icon text-gray-600" />
                            <span className="decision-court">
                                {decision.court} - {decision.id} - {decision.date}
                            </span>
                        </div>
                        <div className="decision-content">
                            <p>{decision.excerpt}</p>
                        </div>
                        <div className="decision-actions">
                            <a
                                href={`/decisions/${decision.id}`}
                                className="voir-decision"
                            >
                                Voir la décision
                                <ExternalLink className="external-icon" size={16} />
                            </a>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default DecisionLieeArticle;